import {observer} from "mobx-react-lite";
import {SortableItem} from "./SortableItem";
import React from "react";
import {stores} from "../../stores";
import {getDisplayPresetNumber} from "../../utils/styling";

export const SortableSelectorWrapper = observer(({presetNumber, itemKey, id, overed, srcElement, ctrlKeyPressed}) => {

    console.log("SortableSelectorWrapper", presetNumber)
    
    // Get the display preset number based on the PRESET_OFFSET setting
    const displayPresetNumber = getDisplayPresetNumber(presetNumber, stores);

    return (
        <div className={`sortable-selector-wrapper`}>
        <div className="preset-number">{displayPresetNumber}</div>
        <SortableItem
            presetNumber={presetNumber}  // Keep original preset number for internal operations
            key={itemKey}
            id={id}
            overed={overed}
            srcElement={srcElement}
            ctrlKeyPressed={ctrlKeyPressed} />
        </div>
    );

});